import React, { useEffect } from 'react';
import { useAuth } from './AuthProvider';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const ORANGE = '#F5A623';
const ORANGE_DARK = '#E09415';

const MicrosoftLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21">
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

const Login = () => {
  const { signIn, account } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (account) navigate('/');
  }, [account, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fafafa',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 360, px: 2 }}>
        {/* Logo */}
        <Box sx={{ mb: 6 }}>
          <Typography sx={{ fontWeight: 800, fontSize: '1.4rem', color: ORANGE, letterSpacing: '-0.3px' }}>
            eYantra
          </Typography>
          <Typography sx={{ fontWeight: 500, fontSize: '0.9rem', color: 'text.secondary' }}>
            Order Management System
          </Typography>
        </Box>

        {/* Heading */}
        <Typography variant="h5" fontWeight={700} color="text.primary" sx={{ mb: 1 }}>
          Sign in
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Continue with your eYantra account
        </Typography>

        {/* Button */}
        <Button
          fullWidth
          onClick={signIn}
          startIcon={<MicrosoftLogo />}
          sx={{
            py: 1.4,
            backgroundColor: ORANGE,
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.95rem',
            textTransform: 'none',
            borderRadius: 2,
            boxShadow: 'none',
            '&:hover': { backgroundColor: ORANGE_DARK, boxShadow: 'none' },
          }}
        >
          Continue with Microsoft
        </Button>
      </Box>

      <Typography variant="caption" color="text.disabled" sx={{ position: 'absolute', bottom: 24 }}>
        © {new Date().getFullYear()} tech-eYantra
      </Typography>
    </Box>
  );
};

export default Login;